<template>
  <layout v-if="!$feature.tempVansNewNav.value" v-bind="$attrs">
    <template v-for="(slot, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps" />
    </template>
  </layout>
  <lazy-pdp-layout-new v-else v-bind="$attrs">
    <template v-for="(slot, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps" />
    </template>
  </lazy-pdp-layout-new>
</template>

<script lang="ts" setup>
const Layout = defineAsyncComponent(() => import('#brand/components/pdp/layout/Layout.vue'))
</script>
